import { alpha } from "@commonlibs";
import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const SelectStyles = css(
    ({ theme: { palette, spacing, borderRadius, border } }) => css`
        //Base styles
        .Select {
            ${getTypographyStyle("body2Strong")};

            .SelectDisplay {
                border: ${palette.components.input.border};
                border-radius: ${borderRadius};
                padding: ${spacing.all(4, 5)};
                .Placeholder {
                    color: ${palette.components.input.placeholderColor};
                }
            }

            .SelectMenu {
                box-shadow: none;
                border: ${border.sm};
                border-radius: ${borderRadius};
                padding: 0;
                margin-top: 0.125rem;
            }

            .SelectItem {
                ${getTypographyStyle("body2Regular")};

                display: flex;
                align-items: center;
                padding: ${spacing.all(2, 5, 2)};

                cursor: pointer;

                &:hover {
                    background-color: ${alpha(palette.primary, 0.12)};
                }

                &.Selected {
                    background-color: ${alpha(palette.primary, 0.3)};
                    ${getTypographyStyle("body2Strong")};
                }
            }
        }

        //Rounded styles
        .FormControl.Rounded {
            .SelectDisplay {
                border-radius: 6249rem;
            }
        }

        //Size styles
        .FormControl.Md {
            .SelectDisplay {
                height: 2.75rem;
            }
        }

        .FormControl.Lg {
            .SelectDisplay {
                height: 3.75rem;
            }
            .SelectItem {
                height: 3.75rem;
                display: flex;
                align-items: center;
            }
        }

        //Variant styles
        .FormControl.Primary {
            .SelectDisplay,
            .SelectMenu {
                background-color: ${palette.primary};
                color: ${palette.gray[0]};
                border: none;
            }

            .SelectDisplay {
                .Placeholder {
                    color: ${palette.overlays[0]["60"]};
                }
            }

            .SelectItem {
                &:hover {
                    background-color: ${alpha(palette.white, 0.12)};
                }

                &.Selected {
                    background-color: ${alpha(palette.text, 0.25)};
                }
            }
        }

        .FormControl.Secondary {
            .SelectDisplay {
                background-color: ${palette.secondary};
                border: none;
            }
        }

        .FormControl.Outlined {
            .SelectDisplay.Open {
                border-color: ${palette.gray[800]};
            }
        }

        .FormControl.Readonly {
            .SelectDisplay,
            .SelectDropdown .Icon {
                color: ${palette.disabled};
            }
        }
    `,
);
